import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { UserDto } from '@bo-client/shared/models/userDto';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-request-entity-detail-page',
  templateUrl: './request-entity-detail-page.component.html',
  styleUrls: ['./request-entity-detail-page.component.scss']
})
export class RequestEntityDetailPageComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  state: string;

  @Input()
  requestEntity: RequestModel;

  @Input()
  errorMessage: string;

  @Input()
  errors: any;

  @Input()
  currentUser: UserDto;

  @Output()
  onActionClickedEvent = new EventEmitter<ActionWithMoreInfoModel>();

  @Input()
  actions: ActionWithMoreInfoModel[] = [];

  // Todo: Andere Request-Models implementieren
  nextActionActive() {
    return this.dataShareService.tenantConfig?.gridRegistration?.nextActionActive;
  }

  constructor(private dataShareService: DataShareService) {}

  get actionButtonsBottom() {
    return this.dataShareService.tenantConfig.style?.actionButtonsBottom ?? false;
  }

  ngOnInit(): void {}
}
